// Persist data tiny library to store and read data
/* global localStorage */
const persistData = {
  setData (name, data) {
    localStorage.setItem(name, JSON.stringify(data))
  },
  getData (name) {
    const stringified = localStorage.getItem(name)
    if (stringified) {
      try {
        return JSON.parse(stringified)
      } catch (err) {
        return stringified
      }
    }
  },
  clearData (name) {
    localStorage.removeItem(name)
  }
}

export default persistData
